import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import Navbar from '../components/Navbar';
import Layout from './Layout';
import Hero from '../components/Hero';
import Product from '../components/Product';
import Slogan from '../components/Slogan';
import Testimonial from '../components/Testimonial';
import Footer from '../components/Footer';
import Loading from '../components/Loading';
import { getSite } from '../tools/fetcher';

export default function Homepage() {
    const { isPending, isError, data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        let x = 1;
        const interval = setInterval(() => {
            const params = new URLSearchParams(window.location.search);
            const section = params.get('section');
            const element = document.getElementById(section);
            if (section) {
                console.log('CLEAR');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    clearInterval(interval);
                }
            }
            x += 1;
            if (x > 50) {
                // 10 seconds
                clearInterval(interval);
            }
        }, 200);
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures this runs only once on mount

    if (isPending) {
        return <Loading />;
    }
    if (isError) {
        return <Loading>Error loading data</Loading>;
    }

    return (
        <Layout className="min-w-[360px] font-dm-sans text-apart-black-100">
            <div className="px-4 sm:px-6 lg:px-8 xl:px-[140px] sm:pt-6 bg-apart-white-50">
                <Navbar data={data} className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="hero"
                className="px-4 pt-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:pt-[80px] bg-apart-white-50"
            >
                <Hero className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="product"
                className="py-[60px] sm:pt-[80px] sm:pb-[120px] bg-apart-white-50"
            >
                <Product
                    className={'px-4 sm:px-6 lg:px-8 xl:px-[140px]'}
                    classNameSlider={'sm:px-6 lg:px-8 xl:px-[140px]'}
                    innerWidth={'mx-auto max-w-[1160px]'}
                />
            </div>
            <div
                id="slogan"
                className="px-4 py-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:pt-[80px] sm:py-[120px] bg-white"
            >
                <Slogan className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="testimonial"
                className="py-[60px] sm:pt-[120px] sm:pb-[60px] bg-apart-white-50"
            >
                <Testimonial
                    className={'px-4 sm:px-6 lg:px-8 xl:px-[140px]'}
                    classNameSlider={'sm:px-6 lg:px-8 xl:px-[140px]'}
                    innerWidth={'mx-auto max-w-[1160px]'}
                />
            </div>
            <div
                id="footer"
                className="px-4 pb-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:py-[120px] sm:pt-[60px] bg-apart-white-50"
            >
                <Footer data={data} className={'max-w-[1160px] mx-auto'} />
            </div>
        </Layout>
    );
}
